import { render } from "./BuildForm.vue?vue&type=template&id=2d68f6be&scoped=true"
import script from "./BuildForm.vue?vue&type=script&lang=js"
export * from "./BuildForm.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=2d68f6be&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d68f6be"]])

export default __exports__